




import {Vue, Component, Mixins} from 'vue-property-decorator';
import PostPurchaseScreen from '@/components/Views/UI/PostPurchaseScreen.vue';
import CancelBookingProcessMixin from '@/mixins/CancelBookingProcessMixin.vue';
@Component({
    components: {
        PostPurchaseScreen,
    },
})
export default class OrderAwaitingReview extends Mixins(CancelBookingProcessMixin) {
    mounted(){
        this.cancelBooking();
    }
}
